function sign(n) {
  return n === 0 ? 0 : n < 0 ? -1 : 1;
}
export {
  sign
};
//# sourceMappingURL=sign.mjs.map
